// ProductImageZoomModal.js
import Component from './component';
import ZoomService from '../product/zoomService';
import swiperHelper from '../product/swiperHelper';
import 'base_global_css/components/productImageZoomModal.scss';

/**
 * productImageZoomModal component
 */
export default class ProductImageZoomModal extends Component {
    constructor(...args) {
        super(...args);
        this.baseUrl = this.el.dataset.baseUrl;
        this.bindEvents();
        return this;
    }

    bindEvents() {
        $('body').on('product:afterAttributeSelect', (event, { data }) => {
            // when ever variation change, new pid is updated to data-url which will reload the pdp zoom modal
            const pid = data.product.id;
            if (pid && this.baseUrl) {
                this.el.dataset.url = `${this.baseUrl}?pid=${pid}`;
            }
        });
    }

    initializeCarousel() {
        // mobile product image slider
        const $carousel = $('.zoomed-images--mob', this.$el);

        // Get viewport dimensions for ratio calc
        var dwidth = $(window).width();
        var dheight = $(window).height();

        // Calculate zoom aspect ratio
        var zoomRatio = (dwidth / dheight) + 1;
        zoomRatio = zoomRatio.toFixed(2); // set zoom ratio per device Rounded to 2 decimal places

        // Calculate slide spacer inversely based on zoom aspect ratio
        // TODO: update this to allow for less device dependancy
        var slideSpacer = ((dwidth / 2) * (1 / zoomRatio)) + (dwidth / 3.5);

        // TODO: update this to allow for less device dependancy
        if(zoomRatio > 1.48) {
            var slideBuffer = (slideSpacer * 43) / 100;
            slideSpacer = slideSpacer - slideBuffer;
        }
        swiperHelper.createSwiperCarousel($carousel, {
            direction: 'horizontal',
            slidesPerView: 1,
            spaceBetween: slideSpacer,
            freeMode: true,
            centeredSlides: true,
            zoom: {
                minRatio: 1.01, // reset - zoom ratio min to just above 1
                initialScale: 1.38, // hard-coded to ensure common metric per device
                maxRatio: 4
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            pagination: {
                el: '.swiper-pagination'
            }
        });
    }

    resetCarousel() {
        var $swiperContainer = $('.zoomed-images--mob', this.$el);

        if ($swiperContainer.hasClass('swiper-initialized') && $swiperContainer[0].swiper) {
            $swiperContainer[0].swiper.destroy(true, true);  // Destroy the Swiper instance
        }
    }

    toggleCarousel() {
        if (['mobile'].includes(this.getCurrentBreakpoint())) {
            this.initializeCarousel();
        } else {
            this.resetCarousel();
        }
    }

    enable() {
        const $mobileModalWrapper = $('.product-image-zoom__wrapper', this.el);
        $mobileModalWrapper.html(this.state.data);
        // FIXME : should move the event binding from zoom service to component later
        ZoomService.init();
        this.toggleCarousel();
    }

    onResize() {
        this.toggleCarousel();
    }
}
